import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const ControlGroupWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;

  ${({ theme }) => `
    bottom: calc(${theme.space.desktop.nano} * 2);
    right: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.lg`
    margin-right: ${theme.space.mobile.base};
    bottom: auto;
    right: auto;
    position: relative;
  `}
`

export const Counter = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.mobile.p};
    font-weight: ${theme.fontWeight.semibold};
    margin-right: ${theme.space.mobile.small};
  `}
`

type ArrowProps = {
  arrowType: 'previous' | 'next'
}

export const Arrow = styled.button<ArrowProps>`
  background: none;

  ${({ theme }) => `
    width: ${theme.space.mobile.large};
    height: ${theme.space.mobile.large};
    border: 1px solid ${theme.color.black};
  `}

  svg {
    display: flex;
    align-items: center;
    margin-top: 1px;
  }

  ${({ disabled }) => `
    opacity: ${disabled ? '.2' : '1'};
  `}

  ${({ theme, arrowType }) =>
    arrowType === 'previous' &&
    `
    margin-right: ${theme.space.mobile.nano};

      svg{
        transform: rotate(-180deg);
      }
  `}
`
